import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Link.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var Link = function Link(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      href = _ref.href,
      light = _ref.light,
      large = _ref.large,
      medium = _ref.medium,
      small = _ref.small,
      targetBlank = _ref.targetBlank,
      underline = _ref.underline;
  var rootClass = cc([css.root, className, _defineProperty({}, css.light, light), _defineProperty({}, css.large, large), _defineProperty({}, css.medium, medium), _defineProperty({}, css.small, small), _defineProperty({}, css.underline, underline)]);
  var targetProps = targetBlank ? {
    rel: 'nooopener noreferrer',
    target: '_blank'
  } : {};
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
    "aria-label": ariaLabel,
    className: rootClass,
    href: href
  }, targetProps), {}, {
    children: children
  }));
};

Link.defaultProps = {
  className: '',
  small: true,
  medium: false,
  large: false,
  light: false,
  targetBlank: false,
  underline: false
};
Link.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.node]).isRequired,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  large: PropTypes.bool,
  light: PropTypes.bool,
  medium: PropTypes.bool,
  small: PropTypes.bool,
  targetBlank: PropTypes.bool,
  underline: PropTypes.bool
};
export default Link;